import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/admin/login');
      return;
    }

    fetch(`${API}/api/auth/session`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then(async (res) => {
        if (!res.ok) throw new Error('Auth failed');
        return res.json();
      })
      .then((data) => {
        setUser(data);
        if (data.is_admin) {
          navigate('/admin', { replace: true, state: { user: data } });
        } else {
          navigate('/admin/login?error=not_admin', { replace: true });
        }
      })
      .catch(() => {
        navigate('/admin/login?error=auth_failed', { replace: true });
      });
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#1F1A17] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#C5A880] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#EADBC8] text-lg">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
